import * as types from './actionTypes'

export const deleteSavedPhoneNumber = () => ({
  type: types.DELETE_PHONE_NUMBER,
})

export const invalidPhone = msg => ({
  type: types.INVALID_PHONE,
  msg,
})


export const emptyFields = msg => ({
  type: types.EMPTY_FIELDS,
})

export const invalidAvatar = msg => ({
  type: types.INVALID_AVATAR,
  msg,
})



// WEBPACK FOOTER //
// ./src/actions/uiActions.js